<template lang="pug">
  .menuBtn
    v-menu.theMenu(open-on-hover :bottom="fromMenu" :offset-y="fromMenu" :right="fromDrawer" :offset-x="fromDrawer")
      template(v-slot:activator='{ on }')
        v-btn.noCursor(v-on="on",text :class="{'v-btn--active': isActive}") Ministries
          
      v-list.theList(color="#3C8C40",dark )
        v-list-item(v-for='(item, index) in items' :key='index' :to="item.path" @click="updateRootPage")
          v-list-item-title.theTitle(two-line) {{ item.title }}
</template>
<script>
export default {
  props: ['fromDrawer', 'fromMenu'],
  data: () => ({
    items: [
      { title: 'Member Services', path: '/ministries/member-services' },
      { title: 'Prayer Circle', path: '/ministries/prayer-circle' },
      { title: 'Education Ministry', path: '/ministries/education' },
      { title: "Men's Ministry", path: '/ministries/mens' },
      { title: 'Word of Mouth Food Pantry', path: '/ministries/food-pantry' },
      { title: 'Worship Art & Music', path: '/ministries/art_music' },
      { title: 'Youth & Young Adult Ministry', path: '/ministries/youth' }
    ]
  }),
  methods: {
    updateRootPage() {
      this.$store.commit('setRoot', 'ministries');
    }
  },
  computed: {
    isActive() {
      let theRoot = this.$store.getters.getRoot;
      console.log('TCL: isActive -> theRoot', theRoot);
      return theRoot == 'ministries' ? true : false;
    }
  }
};
</script>
<style lang="stylus">
.theTitle
  word-wrap normal
</style>
